import { useState } from "react";
import { Input } from "../../components/input.js";
import { Button } from "../../components/button.js";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "../../components/select.js";
import type { ShapeSize } from "./data-table.js";

type Props = {
  onSubmit: (data: any) => void;
  initialValues?: Partial<ShapeSize>;
  isEdit?: boolean;
};

export function ShapeSizeForm({
  onSubmit,
  initialValues = {},
  isEdit = false,
}: Props) {
  const [form, setForm] = useState({
    shape: initialValues?.shape ?? "",
    size: initialValues?.size ?? "",
    wt:
      initialValues?.wt !== undefined && initialValues?.wt !== null
        ? String(initialValues.wt)
        : "0.00",
    status: initialValues?.status?.toString() ?? "1",
  });

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleStatusChange = (value: string) => {
    setForm({ ...form, status: value });
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();

    // const { name } = form;

    const errors = [];

    // if (!name) errors.push("Name is required.");

    if (errors.length > 0) {
      alert(errors.join("\n"));
      return;
    }

    onSubmit(form);
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-4 py-4">
      <Input
        name="shape"
        placeholder="Shape"
        value={form.shape}
        onChange={handleChange}
      />

      <Input
        name="size"
        placeholder="Size"
        value={form.size}
        onChange={handleChange}
      />

      <Input
        name="wt"
        placeholder="Weight"
        type="number"
        step="0.01"
        value={form.wt}
        onChange={handleChange}
      />

      <Select value={form.status} onValueChange={handleStatusChange}>
        <SelectTrigger>
          <SelectValue placeholder="Status" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="1">Enabled</SelectItem>
          <SelectItem value="0">Disabled</SelectItem>
        </SelectContent>
      </Select>

      <Button type="submit">
        {isEdit ? "Update Shape Size" : "Add Shape Size"}
      </Button>
    </form>
  );
}
